import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CommonState {
    [keys: string]: any
}

const initialState: CommonState = {
    cardsPage: 1
}

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setCommonFieldValue(state, action: PayloadAction<{field: string, value: any}>) {

            const field = action.payload.field
            const value = action.payload.value
            state[field] = value
        },
        setCommonManyFieldValue(state, action: PayloadAction<{field: string, value: any}[]>) {
            if(Array.isArray(action.payload) && action.payload?.length) {
                action.payload.forEach((payload: any) => {
                    const field = payload.field
                    const value = payload.value
                    state[field] = value
                })
            }
        },
    },
})

export default commonSlice;
export const { setCommonFieldValue, setCommonManyFieldValue } = commonSlice.actions
export const selectorCommon = (state: any): CommonState => state.getSharedData
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CommonState {
    [keys: string]: any
}

const initialState: CommonState = {
    cardsPage: 1
}

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setCommonFieldValue(state, action: PayloadAction<{field: string, value: any}>) {

            const field = action.payload.field
            const value = action.payload.value
            state[field] = value
        },
        setCommonManyFieldValue(state, action: PayloadAction<{field: string, value: any}[]>) {
            if(Array.isArray(action.payload) && action.payload?.length) {
                action.payload.forEach((payload: any) => {
                    const field = payload.field
                    const value = payload.value
                    state[field] = value
                })
            }
        },
    },
})

export default commonSlice;
export const { setCommonFieldValue, setCommonManyFieldValue } = commonSlice.actions
export const selectorCommon = (state: any): CommonState => state.getSharedData
